module.exports = __webpack_public_path__ + "static/media/add-azure-info.b54baf4c.png";